import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "bs-invoice-search-item__header" }
const _hoisted_2 = { class: "header__title" }
const _hoisted_3 = { class: "header__date" }
const _hoisted_4 = { class: "bs-invoice-search-item__description" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(_component_router_link, {
    class: "bs-invoice-search-item",
    to: `${_ctx.item.type.prefix}${_ctx.item.clientId}`,
    target: "_blank"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.item.type.name) + ": " + _toDisplayString(_ctx.item.clientName), 1),
        _createElementVNode("div", _hoisted_3, "от " + _toDisplayString(_ctx.item.clientCreatedAt), 1)
      ]),
      _createElementVNode("p", _hoisted_4, "Номер: " + _toDisplayString(_ctx.item.clientName), 1)
    ]),
    _: 1
  }, 8, ["to"]))
}